export default [
    {
        path: '/callCenterRequest',
        name: 'callCenterRequest',
        component: () => import('@/views/menu/callCenter/callCenterRequest.vue'),
        meta: {
            pageTitle: 'مدیریت تماس ها',
            action: 'show',
            resource: 'UserCallRequestManager',
        },
    },
    {
        path: '/callCenterList/:id',
        name: 'callCenterList',
        component: () => import('@/views/menu/callCenter/callCenterList.vue'),
        meta: {
            pageTitle: 'لیست تماس ها',
            action: 'show',
            resource: 'UserCallRequestManager',
        },
    },
]